import React from "react";

import CompanyCellContent from "../components/CompanyCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function company({ width, language, onResize }: Column.Options) {
	return base(
		ColumnId.Company,
		(item) => <CompanyCellContent item={item} language={language} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default company;
